export default __webpack_public_path__ + "static/media/Template.72b501f7.png";